import type { InputHTMLAttributes } from 'react';
import React, { forwardRef, useContext } from 'react';

import Checkbox2 from './Checkbox';
import { Context } from './context';

export interface ManagedCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    /**
     * Sets the value attribute for the checkbox option.
     * */
    value: string;
}

const ManagedCheckbox = forwardRef<HTMLInputElement, ManagedCheckboxProps>(({ value, children, ...rest }, ref) => {
    const { name, value: checkedValues, onChange, error } = useContext(Context);

    return (
        <Checkbox2
            ref={ref}
            name={name}
            value={value}
            checked={checkedValues.includes(value)}
            onChange={onChange}
            error={error}
            {...rest}
        >
            {children}
        </Checkbox2>
    );
});

ManagedCheckbox.displayName = 'ManagedCheckbox';

export default ManagedCheckbox;
